import PaginationParser from './PaginationParser';
import PostsParser from './PostsParser';

/**
 * Updates specific parts of the document
 */
export default class PageUpdater {
  constructor(
    private paginationParser: PaginationParser,
    private postsParser: PostsParser
  ) {}

  /**
   * Replaces the pagination container with the given element. If the element is null, the container is emptied
   */
  public replacePagination(replacement: HTMLElement | null): void {
    if (!this.paginationParser.hasPagination()) {
      return;
    }
    const el = this.paginationParser.findPagination();
    el.innerHTML = '';
    if (replacement instanceof HTMLElement) {
      el.appendChild(replacement);
      this.postsParser.getPostsContainer().appendChild(el);
    } else {
      el.remove();
    }
  }

  /**
   * Appends html as string or HTMLELEMENT to the posts container
   */
  public addToPosts(html: HTMLElement[]): void {
    const el = this.postsParser.getPostsContainer();
    html.forEach(m => {
      m.classList.add('lmp-content');
      m.classList.add('lmp-content__new');
      el.appendChild(m);
      setTimeout(() => {
        m.classList.remove('lmp-content__new');
        m.classList.add('lmp-content__loaded');
      }, 50);
    });
  }
}
